import { useEffect, useMemo, useState } from 'react';
import debounce from 'debounce';
import { PendingRequestModal } from 'component/PendingRequestModal';
import { UnsavedDataModal } from '../UnsavedDataModal';

interface UnsavedOrPendingModalProps {
  showPending: boolean;
  showUnsaved?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  isKssSpelling?: boolean;
}

const DEBOUNCE_DELAY = 120;

export const UnsavedOrPendingModal = ({
  showPending: currentShowPending,
  showUnsaved: currentShowUnsaved = false,
  onCancel,
  onConfirm,
  isKssSpelling,
}: UnsavedOrPendingModalProps) => {
  const [showUnsaved, setShowUnsaved] = useState(currentShowUnsaved);
  const [showPending, setShowPending] = useState(currentShowPending);
  const debouncedSetShowUnsaved = useMemo(() => debounce(setShowUnsaved, DEBOUNCE_DELAY), []);
  const debouncedSetShowPending = useMemo(() => debounce(setShowPending, DEBOUNCE_DELAY), []);
  useEffect(() => {
    debouncedSetShowUnsaved(currentShowUnsaved);
  }, [debouncedSetShowUnsaved, currentShowUnsaved]);

  useEffect(() => {
    debouncedSetShowPending(currentShowPending);
  }, [debouncedSetShowPending, currentShowPending]);
  return (
    <>
      <UnsavedDataModal
        isKssSpelling={isKssSpelling}
        onCancel={onCancel}
        onConfirm={onConfirm}
        showModal={showUnsaved}
      />
      <PendingRequestModal visible={showPending} subscribeOnModalClose={onCancel} />
    </>
  );
};
